var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundAuth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 959,
    height: 1024,
    viewBox: "0 0 959 1024",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2348_19238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M959 0H-1V1024H959V0Z",
    fill: "#2A3042"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M-1 344V218.938C138.124 218.938 255.7 126.676 293.881 0H422.844C381.803 196.445 207.633 344 -1 344Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M904 526C664.86 526 471 719.861 471 959C471 981.092 472.654 1002.8 475.846 1024H569.555C565.49 1002.96 563.361 981.228 563.361 959C563.361 770.87 715.87 618.361 904 618.361C922.725 618.361 941.096 619.872 959 622.778V529.46C940.988 527.177 922.632 526 904 526Z",
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2348_19238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 959,
    height: 1024,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundAuth);
export default __webpack_public_path__ + "static/media/backgroundAuth.99fd819c5ccfd096b75a0009194ec0cb.svg";
export { ForwardRef as ReactComponent };